// 弹窗式 Google OAuth 登录的中转常量 + 纯逻辑，src/index.js（弹窗侧）和
// src/hooks/useAuth.js（主窗口侧）共用，避免字符串字面量在两处各写一份、容易漂移。
// 背景见 src/index.js 顶部注释：accounts.google.com 带 Cross-Origin-Opener-Policy 响应头，
// 弹窗跳过去后 window.opener 会被浏览器永久切断，所以弹窗侧判断"我是不是 OAuth 回调"
// 不能依赖 window.opener，只能看 URL 有没有带 code/error 参数。

export const OAUTH_MESSAGE_TYPE = 'primarylens_oauth_code';
export const OAUTH_STORAGE_KEY = 'primarylens_oauth_relay';

/**
 * 判定当前 URL 是否是 Google OAuth 重定向回调（带 code 或 error 参数）。
 * @param {string} search - window.location.search
 * @returns {{code: string|null, error: string|null} | null} 都没有则返回 null（不是回调）
 */
export function parseOAuthCallback(search) {
  const params = new URLSearchParams(search);
  const code = params.get('code');
  const error = params.get('error_description') || params.get('error');
  if (!code && !error) return null;
  return { code: code || null, error: error || null };
}
